import React, { useEffect, useState, useContext } from 'react'
import { SEARCH, SearchContext } from '../search/SearchContext'
import PropTypes from 'prop-types'
import Image from '../common/Image'
import { MHotel } from '../types'
import { getMainImage } from '../helpers/hotelHelper'
import { filterOnlyLoadedImages } from '../helpers/imageHelpers'
import { fetchHotel } from '../helpers/hotelHelper'
import HotelNotFoundImage from '../../../../assets/images/voc/graphics/hotel-default-image.svg'

const HotelImage = ({ hotel, isSearch, children = null }) => {
  const [featuredImages, setFeaturedImages] = useState([])
  const [event, setEvent] = useState(null)
  const { dispatch } = isSearch && useContext(SearchContext)

  useEffect(
    () => {
      if(featuredImages.length && event) {
        // assign first image
        event.src = featuredImages[0] || HotelNotFoundImage
      }
    }, [featuredImages, event]
  )

  // Return only viable images
  const loadImages = (images) => {
    let featured = images || featuredImages
    if(featured.length > 0) {
      const filtered = featured.map((image) => image.hd_size_image_url)
      checkImages(filtered)
    }
  }

  const errorHandler = (el) => {
    if(el) {
      setEvent(el)
      let images = "featured_images" in hotel ? hotel.featured_images : "images" in hotel ? hotel.images : []
      if(images.length) {
        loadImages(images)
      } else {
        const abortController = new AbortController()
        const signal = abortController.signal
        fetchHotel(hotel, { include: 'facilities', signal: signal }).then((response) => {
          if(isSearch) {
            dispatch({
              type: SEARCH.HOTEL.UPDATE,
              payload: {
                hotel: response.data.hotels,
                updateField: 'facilities',
              },
            })
          }
          loadImages(response.data.hotels.facilities)
        })

        return () => {
          abortController.abort()
        }
      }
    }
  }

  // Check if all images exist
  const checkImages     = filtered => filterOnlyLoadedImages(_imagesCallback, ...filtered)
  const _imagesCallback = loaded => setFeaturedImages(loaded.map(image => image.path))

  return <Image
    src={hotel.image || getMainImage(hotel.featured_images || hotel.images)}
    alt={hotel.name}
    errorHandlerCallback={errorHandler}>
      {children && children}
    </Image>
}

HotelImage.defaultProps = {
  isSearch: false
}

HotelImage.propTypes = {
  hotel: MHotel.isRequired,
  fetchImages: PropTypes.func,
  isSearch: PropTypes.bool,
  children: PropTypes.node
}

export default HotelImage
